module.exports = __webpack_public_path__ + "media/assets/images/snow_later_will_cloudy-da5e2db32e5a80bafb6538122e45f65c.png";